import { LoyaltyTierKey } from 'generated/graphql-gateway';
import { useFeatureEarningCalculationQuery } from 'generated/sanity-graphql';

export const useFeaturesEarningCalculations = () => {
  const { data, loading } = useFeatureEarningCalculationQuery({
    variables: { id: 'earningCalculation' },
  });

  return {
    data: data?.EarningCalculation,
    loading,
    getTierEarningData: (loyaltyTierKey?: LoyaltyTierKey | null) =>
      loyaltyTierKey
        ? data?.EarningCalculation?.loyaltyTiersEntranceBehaviorConfigurations?.find(
            val => val?.loyaltyTierKey === loyaltyTierKey
          )
        : null,
  };
};
